import { render, staticRenderFns } from "./NotificationsForSystem.vue?vue&type=template&id=3b274e12"
import script from "./NotificationsForSystem.vue?vue&type=script&lang=js"
export * from "./NotificationsForSystem.vue?vue&type=script&lang=js"
import style0 from "./NotificationsForSystem.vue?vue&type=style&index=0&id=3b274e12&prod&lang=scss"
import style1 from "./NotificationsForSystem.vue?vue&type=style&index=1&id=3b274e12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports